











































































































import { Vue, Component } from 'vue-property-decorator';
import Snackbar from '@/components/shared/Snackbar.vue';
import DossierCounter from '../components/selectors/Dossier/DossierCounter.vue';
import DossierInbounds from '@/components/selectors/Dossier/DossierInbounds.vue';
import DossierInboundsDeliveryNotes from '../components/selectors/Dossier/DossierInboundsDeliveryNotes.vue';
import IInbound from '@/store/models/IInbound';
import IAuthentication from '@/store/models/IAuthentication';
import IRolePermission from '@/store/models/IRolePermission';
import DossierApi from '@/store/api/DossierApi';
import InboundApi from '../store/api/InboundApi';
import SettingsCompanyApi from '@/store/api/SettingsCompanyApi';
import { SettingsCompany } from '@/components/shared/SettingsCompany';
import ISettingsCompany from '@/store/models/ISettingsCompany';
import { IDossierCounter } from '@/store/models/IDossierCounter';
import DossierInboundsNoticeOfLoss from '@/components/selectors/Dossier/DossierInboundsNoticeOfLoss.vue';
import DossierInboundsDocuments from '../components/selectors/Dossier/DossierInboundsDocuments.vue';
import UploadServiceApi from '@/store/api/UploadServiceApi';
import DossierInboundsPictures from '@/components/selectors/Dossier/DossierInboundsPicture.vue';
import DossierOutbounds from '@/components/selectors/Dossier/DossierOutbounds.vue';
import DossierOutboundsDeliveryNotes from '@/components/selectors/Dossier/DossierOutboundsDeliveryNotes.vue';
import DossierOutboundsDocuments from '@/components/selectors/Dossier/DossierOutboundsDocuments.vue';
import DossierOutboundsPictures from '@/components/selectors/Dossier/DossierOutboundsPictures.vue';
import DossierMovements from '@/components/selectors/Dossier/DossierGoodsMovements.vue';
import DossierOutboundsNoticeOfLoss from '@/components/selectors/Dossier/DossierOutboundsNoticeOfLoss.vue';
import PrintingApi from '@/store/api/PrintingApi';
import ICustomer from '../store/models/ICustomer';
import CustomerApi from '@/store/api/CustomerApi';
@Component({
    components: {
        Snackbar,
        DossierCounter,
        DossierInbounds,
        DossierInboundsDeliveryNotes,
        DossierInboundsNoticeOfLoss,
        DossierInboundsDocuments,
        DossierInboundsPictures,
        DossierOutbounds,
        DossierOutboundsDeliveryNotes,
        DossierOutboundsDocuments,
        DossierOutboundsPictures,
        DossierMovements,
        DossierOutboundsNoticeOfLoss
    }
})
export default class Dossiers extends Vue {
  permissions: IRolePermission[] = [];
  idCompany = '';
  InboundList: IInbound[] = [];
  inboundSelected: IInbound = {} as IInbound;
  Counters: IDossierCounter[] = [];
  selectedType = '';
  overlay = false;
  dossierApi = new DossierApi();
  inboundApi = new InboundApi();
  settingsCompanyApi = new SettingsCompanyApi('Dossiers');
  uploadServiceApi = new UploadServiceApi('Dossiers');
  printingApi = new PrintingApi('Printing');
  showCustomer: boolean = false;
  customerApi = new CustomerApi();
  customerList: ICustomer[] = [];

  async created() {
      await this.getPermissions();
      await this.getInbounds();
      await this.getCustomers();
  }

  async getPermissions() {
      const userFromStorage: IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
      this.idCompany = userFromStorage.idCompany;
      this.permissions.push(userFromStorage.rolePermissions.find(r => r.formName === 'Users'));
      let setting : ISettingsCompany[] = await this.settingsCompanyApi.getSettingCompanyId(this.idCompany, SettingsCompany.Settings.ShowCustomer);
      if (setting.length > 0) {
          if (setting[0].value === "No") {
              this.showCustomer = false;
          } else {
              this.showCustomer = true;
          }
      }
  }

  async getInbounds() {
      this.InboundList = await this.inboundApi.GetInboundsCodes(this.idCompany);
  }

  async getCustomers() {
      this.customerList = await this.customerApi.GetCustomersByCompanyId(this.idCompany);
  }

  async onChangeInbound(inboundCode: string) {
      this.overlay = true;
      const found = this.InboundList.find(i => i.code === inboundCode || i.codeDestination === inboundCode);
      if (found) {
          this.Counters = await this.dossierApi.GetCounters(found.code);
          this.inboundSelected = found;
          this.selectedType = '';
      }
      this.overlay = false;
  }

  onSelectType(type: string) {
      if (!this.inboundSelected!.code) {
          (this.$refs.snackbar as Snackbar).showWarning('Please select an inbound first.');
          return;
      }
      if (type === 'PrintDossier') {
          // Llamada directa a la función de impresión
          this.printDossier("xlsx"); // o “pdf”, según formato requerido
          return;
      }
      this.selectedType = type;
  }

  async downloadDocument(document: any) {
      this.overlay = true;
      try {
          this.uploadServiceApi.DownloadDocuments(document.url, document.description);
      } catch (error) {
          console.error("Error downloading document:", error);
          (this.$refs.snackbar as any).showError("Error downloading the document.");
      } finally {
          this.overlay = false;
      }
  }
  async downloadAllDocuments(documents: any[]) {
      if (!documents || documents.length === 0) return;

      this.overlay = true;
      try {
          // Extraemos las URLs válidas
          const urls = documents.map(d => d.url).filter(Boolean);

          if (urls.length === 0) {
              (this.$refs.snackbar as any).showWarning("No document URLs found.");
              return;
          }

          // Detectar extensiones presentes (por ejemplo pdf, jpg, png, docx, etc.)
          const extensions = documents.map(d => {
              const match = d.url!.match(/\.([a-zA-Z0-9]+)(?:\?|$)/);
              return match ? match[1].toLowerCase() : null;
          })
          .filter(Boolean);

          // Si hay varios tipos, usamos 'mixed', si solo hay uno, usamos esa extensión
          const extension =
          extensions.length === 0 ? "zip" : [...new Set(extensions)].length === 1 ? extensions[0] : "mixed";

          const zipFileName = `${this.inboundSelected.code || "Inbound"}_${new Date().toISOString().substr(0, 10)}`;

          // Llamamos a la API pasando la extensión detectada
          await this.uploadServiceApi.DownloadZip(urls, zipFileName, extension);
      } catch (error) {
          console.error("Error creating ZIP:", error);
          (this.$refs.snackbar as any).showError("Error downloading all documents.");
      } finally {
          this.overlay = false;
      }
  }
  async downloadPicture(picture: any) {
      this.overlay = true;
      try {
          await this.uploadServiceApi.DownloadDocuments(picture.url, `Picture_${picture.id}.jpg`);
      } catch (error) {
          console.error(error);
          (this.$refs.snackbar as Snackbar).showError('Error downloading picture');
      } finally {
          this.overlay = false;
      }
  }

  async downloadAllPictures(pictures: any[]) {
      this.overlay = true;
      try {
          const urls = pictures.map(p => p.url);
          const zipFileName = `${this.inboundSelected.code}_${new Date().toISOString().substr(0, 10)}.zip`;
          await this.uploadServiceApi.DownloadZip(urls, zipFileName);
      } catch (error) {
          console.error(error);
      } finally {
          this.overlay = false;
      }
  }

  async printDossier(formatToPrint: string) {
      if (!this.inboundSelected!.id) {
          (this.$refs.snackbar as Snackbar).showWarning("Please select an inbound first.");
          return;
      }

      if (!this.idCompany) {
          (this.$refs.snackbar as Snackbar).showWarning("Company not found.");
          return;
      }

      // Si no es superadmin, procede
      if ((this as any).isSuperAdmin === false || (this as any).isSuperAdmin === undefined) {
          try {
              this.overlay = true;

              const settingsCompany = SettingsCompany.Settings.IdDossierPrinting;
              const idReport: ISettingsCompany[] = await this.settingsCompanyApi.getSettingCompanyId(this.idCompany, settingsCompany);

              if (idReport!.length > 0) {
                  const ids: string[] = [this.inboundSelected.id];
                  const printDossierUrl: string = await this.printingApi.Print(
                      idReport[0].value,
                      "IdInbound",
                      ids,
                      formatToPrint
                  );

                  if (printDossierUrl) {
                      await this.uploadServiceApi.DownloadDocuments(
                          printDossierUrl,
                          `Dossier_${this.inboundSelected.code}.xlsx`
                      );
                      (this.$refs.snackbar as Snackbar).showInfo("Dossier printed successfully.");
                  }
              } else {
                  (this.$refs.snackbar as Snackbar).showWarning(`Setting ${settingsCompany} could not be found`);
              }
          } catch (err) {
              console.error("❌ Error printing dossier:", err);
              (this.$refs.snackbar as Snackbar).showError("Error printing dossier");
          } finally {
              this.overlay = false;
          }
      } else {
          (this.$refs.snackbar as Snackbar).showWarning("SuperAdmin has no company settings.");
      }
  }
}
